import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createHubBand, updateHubBand , removeHubBand , getHubBandAPI} from '../api/util';
import { RootState } from '../store';


export interface ProjectState {
    hubModelList?: any[],
    newProjectResponse?:any,
    fetching: boolean,
}

const initialState: ProjectState = {
    hubModelList: undefined,
    fetching:false

}


export const createNewHubModel = createAsyncThunk(
    'bladeModal/createHubBand',
    async (data: any, thunkAPI) => {
        try {
            const response = await createHubBand(data); // Assuming createBladeModel is an asynchronous function
            return response.response;
        } catch (error) {
            console.log("createNewModel", error);
            return error;
        }
    }
);
export const updateNewHubModel = createAsyncThunk(
    'bladeModal/updateHubBand',
    async (data: any) => {
        const response = await updateHubBand(data);
        console.log("createNewModel",response.response)
        return response.response;
    }
);


export const removeNewHubModel = createAsyncThunk(
    'bladeModal/removeHubBand',
    async (data: any) => {
        const response = await removeHubBand(data);
        console.log("createNewModel",response.response)
        return response.response;
    }
);

export const getHubModels = createAsyncThunk(
    'bladeModal/getHubBandAPI',
    async () => {
        const response = await getHubBandAPI();
        console.log("getBladeModels",response.response)
        return response.response;
    }
);


export const HubModelSlice = createSlice({
    name: 'hubModel',
    initialState,
    reducers: {
        resetBladeModelStore: (state) => {
            state = initialState;
        }
    }, extraReducers: (builder) => {
        builder
            .addCase(getHubModels.pending, (state) => {
                state.fetching = true;
                state.hubModelList = undefined
            })
            .addCase(getHubModels.fulfilled, (state, action) => {
                state.fetching = false;
                state.hubModelList = action.payload.data;
            })
            .addCase(getHubModels.rejected, (state) => {
                state.fetching = false;
            })

            .addCase(updateNewHubModel.pending, (state) => {
                state.fetching = true;
                state.hubModelList = undefined
            })
            .addCase(updateNewHubModel.fulfilled, (state, action) => {
                state.fetching = false;
                state.hubModelList = action.payload.data;
            })
            .addCase(updateNewHubModel.rejected, (state) => {
                state.fetching = false;
            })


            .addCase(removeNewHubModel.pending, (state) => {
                state.fetching = true;
                state.hubModelList = undefined
            })
            .addCase(removeNewHubModel.fulfilled, (state, action) => {
                state.fetching = false;
                state.hubModelList = action.payload.data;
            })
            .addCase(removeNewHubModel.rejected, (state) => {
                state.fetching = false;
            })

            .addCase(createNewHubModel.pending, (state,action) => {
                state.fetching = true;
                state.newProjectResponse = undefined
            })
            .addCase(createNewHubModel.fulfilled, (state, action) => {
              
                state.fetching = false;
                state.newProjectResponse = action.payload
            })
            .addCase(createNewHubModel.rejected, (state,action) => {
                state.fetching = false;
                state.newProjectResponse = action.error.message ;
            })
    }
})


export const { resetBladeModelStore } = HubModelSlice.actions;

export const getBladeModelList = (state: RootState) => state.hubModel.hubModelList;
export const newProjectResponse = (state: RootState) => state.hubModel.newProjectResponse;


export default HubModelSlice.reducer;